<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card :loading="loading">
        <div slot="title"><a-icon type="file-search" />&nbsp;Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse activeKey="0">
              <a-collapse-panel key="0">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-range-picker
                    :placeholder="['Start Date', 'End Date']"
                    v-model="searchDate"
                    :format="getDefaultDateFormat"
                    allowClear
                  />
                </div>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Status</label>
                  <a-select
                    placeholder="Ex: Approved ... "
                    v-model="status"
                    class="width-full"
                    initialValue="delivered"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in getStatus"
                      :key="item.id"
                      :value="item.value"
                      >{{ item.label }}</a-select-option
                    >
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList
        :loading="loading"
        title="Salary Component List"
        :createLink="gettoCreate"
        :manifestLink="getManifest"
        :editLink="gettoEdit"
        :dataList="searching"
        :estimasi="true"
        :isTransactional="true"
        :allowcancel="true"
        :disabledCreateEditLink="!allowCreate"
      />
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";

moment.locale('en')

export default {
  name: "listSalaryComponent",
  mixins: [CurrencyFormat],
  data() {
    return {
      loading: true,
      dataList: [],
      basedList: [],
      searchDate: [],
      search: "",
      status: undefined,
      allowCreate: false
    };
  },
  created() {
    this.$store.dispatch("FETCH_ALL_MATA_UANG");
    this.fetchData();
  },
  mounted() {
    Event.$on("handleCancel", this.canceltrans);

    if(this.isHRD){
      this.allowCreate = true;
    }
  },
  beforeDestroy() {
    Event.$off("handleCancel", this.canceltrans);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStatus",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    getManifest(){
      return this.$route.meta.ishrd ? 'salary-component-manifest-hrd' :'salary-component-manifest-dir'
    },
    gettoCreate(){
      return this.$route.meta.ishrd ? 'salary-component-create-hrd' :'salary-component-create-dir'
    },
    gettoEdit(){
      return this.$route.meta.ishrd ? 'salary-component-edit-hrd' :'salary-component-edit-dir'
    },
    searching() {
      let output = this.dataList;

      if (this.search) {
        output = output.filter(
          (obj) =>
            obj.searchQ &&
            obj.searchQ.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }
      
      if (this.searchDate && this.searchDate.length > 0) {
        let startDt = moment(this.searchDate[0]).format(this.getDefaultDateFormat);
        let endDt = moment(this.searchDate[1]).format(this.getDefaultDateFormat);

        output = output.filter(
          (obj) =>
            obj.tgl_buat &&
            moment(obj.tgl_buat).format(this.getDefaultDateFormat) >= startDt &&
            moment(obj.tgl_buat).format(this.getDefaultDateFormat) <= endDt
        );
      }

      if (this.status) {
        output = output.filter(
          (obj) =>
            obj.status && obj.status.toLowerCase().indexOf(this.status.toLowerCase()) >= 0
        );
      }

      return output;
    },
    isHRD(){
      let res = false
      this.getAuth.divisi.forEach(element => {
        if(element.toLowerCase()=='hrd'){
          res = true
        }
      });
      return res
    },
  },
  methods: {
    moment,
    fetchData() {
      axios({
        method: "get",
        url: this.$serviceUrl + "komponen_gaji",
        params: {
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.basedList = response.data.data;

          response.data.data.forEach((data) => {
            this.dataList.push({
              id: data.id_komponen_gaji_hdr,
              title: moment(data.periode, this.getDefaultDateFormat).format("MMMM YYYY").toLocaleUpperCase(),
              subtitle: { 
                "Create Date": data.create_dt 
              },
              timeline: JSON.parse(data.status_app),
              subdesc: [
                [
                   {
                     label: "Create Date",
                     value: moment(data.tgl_buat).format(this.getDefaultDateFormat),
                   },
                 ],
                 data.catatan,
              ],
              status: data.status,
              tgl_buat: data.tgl_buat,
              searchQ:
              moment(data.periode, this.getDefaultDateFormat).format("MMMM YYYY").toLocaleUpperCase() + 
              (data.catatan?data.catatan.toLowerCase():"") + 
              data.status.toLowerCase()+
              moment(data.tgl_buat).format(this.getDefaultDateFormat)
            });
          });

          this.loading = false;
        })
        .catch((err) => {
          if (!err.response) {
            this.loading = false;
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
    canceltrans(item) {
      axios({
        method: "post",
        url: this.$serviceUrl + "main/cancel_transaction",
        params: {
          tlc: this.getAuth.username,
        },
        data: {
          tlc: this.getAuth.username,
          jenis_trans: "pp",
          id_manifest: item.id,
          code_trans: item.title,
          kode_project: item.kode_project,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.displayMessageValue("successCancel", response.data.message);
          this.fetchData();
          this.searching;
          this.$router.go(0);

        })
        .catch((err) => {
          console.log(err);
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
  },
};
</script>

<style>
</style>